import React, { Fragment } from 'react';
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../actions/dCandidate";
import anime from 'animejs';
import axios from 'axios';
import { BrowserRouter, Route, Link, Routes } from 'react-router-dom';

const QRContact = (props) => {
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [answer, setAnswer] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        comment: ''
    });

    useEffect(() => {
        props.fetchData();
        setNum1(Math.floor(Math.random() * 10));
        setNum2(Math.floor(Math.random() * 10));

        // anime.js animations (unchanged)
        // ...
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'answer') {
            setAnswer(value);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const correctAnswer = num1 + num2;
        if (parseInt(answer) !== correctAnswer) {
            alert("Incorrect answer to the math question. Please try again.");
            return;
        }

        const payload = {
            Name: formData.name,
            PhoneNo: formData.phone,
            token: process.env.REACT_APP_APP_TOKEN // Replace with actual token logic
        };
        console.log(payload);
        try {
            const response = await axios.post('https://dot.infobytes.dev/api/Front/SaveLead', payload);
            // const response = await axios.post('https://localhost:7153/api/Front/SaveLead', payload);

            console.log("Lead saved:", response.data);
            alert("Lead submitted successfully!");
        } catch (error) {
            console.error("Error saving lead:", error);
            alert("Failed to submit lead.");
        }
    };

    useEffect(() => {
        props.fetchData();
        anime({
            targets: '[data-anime]', // Select elements with the data attribute
            el: "childs", translateY: [30, 0], opacity: [0, 1], duration: 400, delay: 0, staggervalue: 100, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-anime-1]', // Select elements with the data attribute
            translateY: [-50, 0], opacity: [0, 1], duration: 600, delay: 0, staggervalue: 300, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-anime-2]', // Select elements with the data attribute
            e1: "childs", translateY: [30, 0], opacity: [0, 1], duration: 800, delay: 0, staggervalue: 300, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-anime-3]', // Select elements with the data attribute
            e1: "childs", translateX: [50, 0], opacity: [0, 1], duration: 600, delay: 0, staggervalue: 300, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-anime-4]', // Select elements with the data attribute
            translateX: [0, 0], opacity: [0, 1], duration: 600, delay: 250, staggervalue: 300, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-anime-5]', // Select elements with the data attribute
            el: "childs", translateY: [30, 0], opacity: [0, 1], duration: 800, delay: 0, staggervalue: 300, easing: "easeOutQuad"
        });
        //'{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 800, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
        anime({
            targets: '[data-anime-6]', // Select elements with the data attribute
            el: "childs", translateY: [30, 0], opacity: [0, 1], duration: 800, delay: 0, staggervalue: 300, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-fancy-text]', // Select elements with the data attribute
            opacity: [0, 1], translateY: [50, 0], filter: ["blur(20px)", "blur(0px)"], duration: 400, delay: 0, speed: 50, easing: "easeOutQuad"
        });
        anime({
            targets: '[data-fancy-text-1]', // Select elements with the data attribute
            opacity: [0, 1], translateY: [50, 0], filter: ["blur(20px)", "blur(0px)"], "string": ["Let&apos;s discuss your problems now"], duration: 400, delay: 0, speed: 50, easing: "easeOutQuad"
        });
    }, [])

    return (
        <Fragment>
            <section className="page-title-big-typography bg-dark-gray ipad-top-space-margin xs-py-0 cover-background background-position-center-top" style={{ backgroundImage: "url(assets/images/others/about_us.jpeg)", zIndex: 0 }}>
                <div class="opacity-extra-medium bg-gradient-black-green"></div>
                <div class="container">
                    <div class="row align-items-center justify-content-center small-screen">
                        <div class="col-xl-6 col-lg-7 col-sm-8 position-relative text-center page-title-extra-small" data-anime>
                            <div>
                                <h1 class="text-uppercase mb-15px alt-font text-white opacity-6 fw-500 ls-2px"
                                    data-fancy-text>
                                </h1>
                            </div>
                            <h2 class="m-auto text-white alt-font text-shadow-double-large fw-700 w-90 xl-w-100"
                                data-fancy-text-1>
                            </h2>
                        </div>
                        <div class="down-section text-center" data-anime-1>
                            <a href="#down-section" class="section-link">
                                <div class="text-white">
                                    <i class="line-icon-Down icon-medium"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="container">
                    <div class="row justify-content-center mb-3">
                        <div class="col-lg-7 text-center"
                            data-anime-3>
                            <span class="alt-font text-uppercase fw-600 d-inline-block ls-1px">Feel free to get in touch!</span>
                            <h3 class="alt-font text-dark-gray fw-600 ls-minus-1px shadow-none" data-shadow-animation="true"
                                data-animation-delay="1000">How we can <span class="text-highlight fw-800">help<span
                                    class="bg-gradient-emerald-blue-emerald-green h-8px bottom-10px opacity-6 separator-animation"></span></span>
                                you?</h3>
                        </div>
                    </div>
                    <div class="row row-cols-md-1 justify-content-center">
                        <div class="col-xl-9 overflow-hidden">
                            <form class="row" data-anime-4 onSubmit={handleSubmit}>
                                <div class="col-md-6 mb-30px">
                                    <input
                                        className="input-name form-control required"
                                        type="text"
                                        name="name"
                                        placeholder="Your name*"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div class="col-md-6 mb-30px">
                                    <input
                                        className="form-control required"
                                        type="tel"
                                        name="phone"
                                        placeholder="Your phone*"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div class="col-xl-6 col-md-7 last-paragraph-no-margin">
                                    <p class="text-center text-md-start fs-15 lh-28">We are committed to protecting your privacy. We
                                        will never collect information about you without your explicit consent.</p>
                                </div>
                                <label>
                                    What is {num1} + {num2}?
                                    <input type="number" name="answer" value={answer} onChange={handleChange} required />
                                </label>
                                <div class="col-xl-6 col-md-5 text-center text-md-end sm-mt-20px">
                                    <input type="hidden" formControlName="redirect" value="" />
                                    <br />
                                    <button class="btn btn-primary btn-small btn-round-edge" type="submit">Send
                                        message</button>
                                </div>
                                <div class="col-12">
                                    <div class="form-results mt-20px d-none"></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section id="down-section" class="bg-very-light-gray overflow-hidden">
                <div class="row row-cols-1 row-cols-lg-4 row-cols-md-2 justify-content-center"
                    data-anime-5>
                    <div class="col rotate-box-style-02 md-mb-30px">
                        <div class="row justify-content-center g-0">
                            <div
                                class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-40px xs-border-radius-10px">
                                <div class="feature-box overflow-hidden">
                                    <div class="text-dark-gray text-uppercase">
                                        <i class="bi bi-lightning-charge icon-extra-medium text-base-color"></i> Regular
                                        Workshops <a href="sadhanas"
                                            class="text-base-color text-decoration-line-bottom-medium border-1"></a>
                                    </div>
                                </div>
                                <div class="feature-box feature-box-left-icon-middle">
                                    <ul class="space-y-2 text-gray-700">
                                        <li class="flex items-center"><span class="text-purple-600 mr-2">🔹</span>श्री
                                            मंत्रशास्त्र
                                            कार्यशाळा
                                        </li>
                                        <li class="flex items-center"><span class="text-purple-600 mr-2">🔹</span>श्री
                                            वैभवलक्ष्मी कार्यशाळा
                                        </li>
                                        <li class="flex items-center"><span class="text-purple-600 mr-2">🔹</span>श्री
                                            शाबरीविद्या कार्यशाळा
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col rotate-box-style-02 md-mb-30px">
                        <div class="row justify-content-center g-0">
                            <div
                                class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-40px xs-border-radius-10px">
                                <div class="feature-box overflow-hidden">
                                    <div class="text-dark-gray text-uppercase">
                                        <i class="bi bi-calendar-event icon-extra-medium text-base-color"></i> Upcoming
                                        Workshops<a href="sadhanas"
                                            class="text-base-color text-decoration-line-bottom-medium border-1"></a>
                                    </div>
                                </div>
                                <div class="feature-box feature-box-left-icon-middle">
                                    <ul class="space-y-2 text-gray-700">
                                        <li class="flex items-center"><span class="text-blue-600 mr-2">🔸</span>श्री मुद्रा
                                            कार्यशाळा</li>
                                        <li class="flex items-center"><span class="text-blue-600 mr-2">🔸</span>ध्यानतंत्र
                                            कार्यशाळा</li>
                                        <li class="flex items-center"><span class="text-blue-600 mr-2">🔸</span>श्री
                                            यंत्रशास्त्र कार्यशाळा
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col rotate-box-style-02 md-mb-30px">
                        <div class="row justify-content-center g-0">
                            <div
                                class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-40px xs-border-radius-10px">
                                <div class="feature-box overflow-hidden">
                                    <div class="text-dark-gray text-uppercase">
                                        <i class="bi bi-hourglass-split icon-extra-medium text-base-color"></i> Occasional
                                        Spiritual Practices <a href="sadhanas"
                                            class="text-base-color text-decoration-line-bottom-medium border-1"></a>
                                    </div>
                                </div>
                                <div class="feature-box feature-box-left-icon-middle">
                                    <ul class="space-y-2 text-gray-700">
                                        <li class="flex items-center"><span class="text-green-600 mr-2">🔹</span>पुरूषोत्तम मास
                                            साधना</li>
                                        <li class="flex items-center"><span class="text-green-600 mr-2">🔹</span>श्री गणपती
                                            अथर्वशीर्ष सहस्रावर्तन साधना</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col rotate-box-style-02 md-mb-30px">
                        <div class="row justify-content-center g-0">
                            <div
                                class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-40px xs-border-radius-10px">
                                <div class="feature-box overflow-hidden">
                                    <div class="text-dark-gray text-uppercase">
                                        <i class="bi bi-chat-square-text icon-extra-medium text-base-color"></i> Counseling
                                        Sessions <a href="sadhanas"
                                            class="text-base-color text-decoration-line-bottom-medium border-1"></a>
                                    </div>
                                </div>
                                <div class="feature-box feature-box-left-icon-middle">
                                    <ul class="space-y-2 text-gray-700">
                                        <li class="flex items-center"><span class="text-orange-600 mr-2">🔸</span>वैयक्तिक
                                            समस्या निराकरणासाठी</li>
                                        <li class="flex items-center"><span class="text-orange-600 mr-2">🔸</span>विद्यार्थ्यांना
                                            करिअर मार्गदर्शनासाठी</li>
                                        <li class="flex items-center"><span class="text-orange-600 mr-2">🔸</span>व्यावसायिक
                                            मार्गदर्शनासाठी</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row row-cols-1 row-cols-lg-1 row-cols-md-2 justify-content-center" data-anime-6>
                    <div class="col rotate-box-style-02 md-mb-30px">
                        <div class="row justify-content-center g-0">
                            <div
                                class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-40px xs-border-radius-10px">
                                <div class="feature-box overflow-hidden">
                                    <div class="text-dark-gray text-uppercase">
                                        <i class="bi bi-person-arms-up icon-extra-medium text-base-color"></i> Sadhana <a
                                            href="sadhanas" class="text-base-color text-decoration-line-bottom-medium border-1"></a>
                                    </div>
                                </div>
                                <div class="feature-box feature-box-left-icon-middle">
                                    <ul class="space-y-2 text-gray-700">
                                        <li class="flex items-center"><span class="text-red-600 mr-2">🔹</span>श्री महाशिवरात्रि
                                            जागरण साधना</li>
                                        <li class="flex items-center"><span class="text-red-600 mr-2">🔹</span>श्री रामनवरात्र
                                            साधना</li>
                                        <li class="flex items-center"><span class="text-red-600 mr-2">🔹</span>श्री हनुमान
                                            सिद्धी साधना</li>
                                    </ul>
                                    <ul class="space-y-2 text-gray-700">
                                        <li class="flex items-center"><span class="text-red-600 mr-2">🔹</span>पितृदोष शांती
                                            साधना</li>
                                        <li class="flex items-center"><span class="text-red-600 mr-2">🔹</span>श्री देवी नवरात्र
                                            साधना</li>
                                        <li class="flex items-center"><span class="text-red-600 mr-2">🔹</span>श्री महालक्ष्मी
                                            साधना</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row row-cols-1 row-cols-lg-1 row-cols-md-1 justify-content-center"
                    data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 800, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                    <div class="col rotate-box-style-02 md-mb-30px">
                        <div class="row justify-content-center g-0">
                            <div
                                class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-40px xs-border-radius-10px">
                                <div class="feature-box overflow-hidden">
                                    <div class="text-dark-gray text-uppercase">
                                        <i class="bi bi-mic icon-extra-medium text-base-color"></i> Divine Teachings <a
                                            href="sadhanas" class="text-base-color text-decoration-line-bottom-medium border-1"></a>
                                    </div>
                                </div>
                                <div class="feature-box feature-box-left-icon-middle">
                                    <p class="text-gray-700 leading-relaxed">
                                        मंत्र, यंत्र, तंत्र, ध्यान, कुंडलिनी, चक्र, गायत्री मंत्र, विविध साधनाओं और स्तोत्रों पर
                                        जागरूकतापूर्ण व्याख्यान।
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}
const mapStateToProps = (state) => {
    return { data: state.dCandidate.list };
};

const mapActionToProps = {
    fetchData: actions.fetchallContact
}

export default connect(mapStateToProps, mapActionToProps)(QRContact);